<template>
    <auction-dialog title="예상 배송비 안내" @open="init">
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template #default>
            <p class="font-size-14 font-size-md-16">
                기본 배송지 기준<strong class="font-size-16 font-size-md-20 pl-8">{{ delivery }}원</strong>
            </p>
            <div class="mt-6 mt-md-10">
                <v-card tile elevation="0" class="grey-ef">
                    <v-card-text class="pa-16 pa-md-24">
                        <p class="font-size-14 grey-68--text">
                            온라인 경매의 낙찰작은 직접 픽업이 원칙입니다.<br />
                            만약, 픽업이 불가능한 경우 배송을 요청할 수 있으며, 아래와 같이 배송비가 부과됩니다.
                        </p>
                    </v-card-text>
                </v-card>
            </div>
            <div class="mt-14 mt-md-20">
                <v-data-table :headers="headers" :items="items" hide-default-footer disable-sort :items-per-page="-1" class="v-data-table--default v-data-table--none-active-bg">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                    <template #[`item.domestic`]="{value}">
                        <div class="ma-md-n4" style="margin-bottom:-5px!important;">
                            <v-row no-gutters justify="end" justify-sm="center" v-for="{ region, amount } in value" :key="region">
                                <v-col cols="auto" md="4" class="border-md-bottom">
                                    <span class="d-none d-md-flex align-center justify-center h-md-60px font-weight-medium grey-ef">{{ region }}</span>
                                    <span class="d-md-none font-weight-medium pr-10">{{ region }}</span>
                                </v-col>
                                <v-col cols="auto" md="8" class="border-md-bottom">
                                    <div class="d-flex align-center justify-center h-md-60px">{{ amount.format() }}원</div>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                    <template #[`item.overseas`]="{value}">
                        <span>
                            {{ value }}
                        </span>
                    </template>
                </v-data-table>
            </div>
            <div class="mt-12">
                <p class="font-size-14 grey-68--text">
                    동일 경매에서 1점 초과 낙찰시, 초과분부터 1만원씩 추가 (단, 동일장소/일시인 경우에 한함)<br />
                    예) 서울 지역 3점 낙찰 : 5만원+1만원+1만원 = 7만원
                </p>
            </div>
        </template>
    </auction-dialog>
</template>

<script>
import api from "@/api";
import AuctionDialog from "./auction-dialog.vue";
import { DELIVERY_POLICIES_DOMESTIC } from "@/assets/variables";

const headers = [
    { align: "center", text: "국내", value: "domestic", divider: true },
    { align: "center", text: "해외", value: "overseas" },
];

const items = [
    {
        domestic: DELIVERY_POLICIES_DOMESTIC,
        overseas: "별도배송비",
    },
];

export default {
    components: { AuctionDialog },
    props: {
        work: { type: Object, default: () => ({}) },
    },
    data: () => ({
        user: null,
        items,
        headers,
    }),
    computed: {
        delivery() {
            const { address1 = "" } = this.user || {};
            if (address1 == "") return 0;

            const policy = DELIVERY_POLICIES_DOMESTIC.find(({ test }) => test(address1));
            return policy?.value?.format?.();
        },
    },
    methods: {
        async init() {
            const { user } = await api.v1.me.get();
            this.user = user;
        },
    },
};
</script>

<style></style>
